module.exports = __webpack_public_path__ + "img/img_014@2x.003846bb.png";